import { z } from "zod"
import { Currency } from "@/modules/organizations/enums/currency"

export const companyFormSchema = z.object({
  companyName: z
    .string()
    .min(1, "Company name is required")
    .max(150, "Company name must be 150 characters or less")
    .regex(
      /^[a-zA-Z0-9\s&.'(),-]+$/,
      "Company name can only contain letters, numbers, spaces, and & - . ' ( ) ,",
    ),
  streetAddress: z
    .string()
    .min(1, "Street address is required")
    .max(250, "Street address must be 250 characters or less")
    .regex(
      /^[a-zA-Z0-9\s#.,/-]+$/,
      "Street address can only contain letters, numbers, spaces, and # - . , /",
    ),
  city: z
    .string()
    .min(1, "City is required")
    .max(100, "City must be 100 characters or less")
    .regex(
      /^[a-zA-Z\s'.,-]+$/,
      "City can only contain letters, spaces, and - ' .",
    ),
  state: z
    .string()
    .min(1, "State/Province is required")
    .max(100, "State/Province must be 100 characters or less")
    .regex(
      /^[a-zA-Z\s'.,-]+$/,
      "State/Province can only contain letters, spaces, and - ' .",
    ),
  zipCode: z
    .string()
    .min(1, "ZIP/Postal code is required")
    .max(20, "ZIP/Postal code must be 20 characters or less")
    .regex(
      /^[a-zA-Z0-9\s-]+$/,
      "ZIP/Postal code can only contain letters, numbers, spaces, and -",
    ),
  country: z
    .string()
    .min(1, "Country is required")
    .max(100, "Country must be 100 characters or less")
    .regex(
      /^[a-zA-Z\s'.(),-]+$/,
      "Country can only contain letters, spaces, and - ' . ( )",
    ),
  description: z
    .string()
    .max(1000, "Description must be 1000 characters or less")
    .optional(),
  currency: z.nativeEnum(Currency),
})

export type CompanyFormValues = z.infer<typeof companyFormSchema>
